<script>
import { fade } from 'svelte/transition';
import CustomIcon from '../components/CustomIcon.svelte';
import Menu from './Menu.svelte';

  let logoUrl = '/assets/logo/logo_symbol.png';
  export let showMenu = false;
  export let onClose = () => {};
</script>

{#if showMenu}
  <!-- Off-canvas menu for mobile, show/hide based on off-canvas menu state. -->
  <div
    transition:fade
    class="fixed inset-0 flex z-40 md:hidden"
    role="dialog"
    aria-modal="true"
  >
    <!--
      Off-canvas menu overlay, show/hide based on off-canvas menu state.

      Entering: "transition-opacity ease-linear duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "transition-opacity ease-linear duration-300"
        From: "opacity-100"
        To: "opacity-0"
    -->

    <div class="fixed inset-0 bg-gray-600 bg-opacity-75" aria-hidden="true" />
    <!--
      Off-canvas menu, show/hide based on off-canvas menu state.

      Entering: "transition ease-in-out duration-300 transform"
        From: "-translate-x-full"
        To: "translate-x-0"
      Leaving: "transition ease-in-out duration-300 transform"
        From: "translate-x-0"
        To: "-translate-x-full"
    -->
    <div class="relative flex-1 flex flex-col max-w-xs w-full bg-white">
      <!--
        Close button, show/hide based on off-canvas menu state.

        Entering: "ease-in-out duration-300"
          From: "opacity-0"
          To: "opacity-100"
        Leaving: "ease-in-out duration-300"
          From: "opacity-100"
          To: "opacity-0"
      -->
      <div class="absolute top-0 right-0 -mr-12 pt-2">
        <button
          on:click={onClose}
          class="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
        >
          <span class="sr-only">Close sidebar</span>
          <!-- Heroicon name: outline/x -->
          
          <CustomIcon name="outline" color="white"/>
        </button>
      </div>

      <div class="flex-1 h-0 pt-5 pb-4 overflow-y-auto">
        <div class="shrink-0 flex items-center px-4">
          <img class="h-8 w-auto" src={logoUrl} alt="Workflow" />
        </div>
        <Menu />
      </div>
      <div class="shrink-0 flex border-t border-gray-200 p-4">
        <a href="/" class="shrink-0 group block">
          <div class="flex items-center">
            <div>
              <img
                class="inline-block h-10 w-10 rounded-full"
                src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                alt=""
              />
            </div>
            <div class="ml-3">
              <p
                class="text-base font-medium text-gray-700 group-hover:text-gray-900"
              >
                Tom Cook
              </p>
              <p
                class="text-sm font-medium text-gray-500 group-hover:text-gray-700"
              >
                View profile
              </p>
            </div>
          </div>
        </a>
      </div>
    </div>

    <div class="shrink-0 w-14">
      <!-- Force sidebar to shrink to fit close icon -->
    </div>
  </div>
{/if}
